const dateTime = new Intl.DateTimeFormat("en-GB", { dateStyle: "medium", timeStyle: "short" });
const dateOnly = new Intl.DateTimeFormat("en-GB", { dateStyle: "medium" });
const number = new Intl.NumberFormat("en-US");

export const formatDateTime = (value: string | null | undefined) =>
  value ? dateTime.format(new Date(value)) : "—";
export const formatDate = (value: string | null | undefined) =>
  value ? dateOnly.format(new Date(value)) : "—";
export const formatNumber = (value: number) => number.format(value);

export function formatDuration(totalSeconds: number): string {
  if (totalSeconds < 60) return `${Math.round(totalSeconds)}s`;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  return hours > 0
    ? `${number.format(hours)}h ${minutes}m`
    : `${minutes}m ${Math.round(totalSeconds % 60)}s`;
}

export function relativeTime(value: string): string {
  const seconds = Math.round((Date.now() - new Date(value).getTime()) / 1000);
  if (seconds < 60) return "just now";
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
  if (seconds < 86_400) return `${Math.floor(seconds / 3600)} h ago`;
  return `${Math.floor(seconds / 86_400)} d ago`;
}

export function isoDay(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function daysAgo(days: number): string {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() - days);
  return isoDay(date);
}

const dayShort = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "short" });

/** `2026-09-06` → `6 Sep`, for axis ends where the year is obvious from context. */
export function shortDay(day: string | undefined): string {
  return day ? dayShort.format(new Date(`${day}T00:00:00Z`)) : "";
}
